export default __webpack_public_path__ + "static/media/Welcome_Page.a1082752.jpg";